import { DisabledComponent } from './style';

interface DisabledProps {
    condition?: boolean;
    children?: React.ReactNode;
}

const Disabled = ({ condition = true, children, ...other }: DisabledProps) => (
    <DisabledComponent aria-disabled={condition} condition={condition} {...other}>
        {children}
    </DisabledComponent>
);

export default Disabled;
